import { FC } from 'react'

import { Dialog, DialogContent } from '@mui/material'

import { MentorCloudRenameForm } from '../MentorCloudRenameForm'

import { MentorCloudFileFilters } from 'src/types/files/file'

interface MentorCloudRenameModalProps {
  isOpen: boolean
  filters: MentorCloudFileFilters
  onClose: () => void
  parentFolderId?: number | null
  fileId?: number
  fileName?: string
  type?: 'file' | 'folder'
}

export const MentorCloudRenameModal: FC<MentorCloudRenameModalProps> = props => {
  const { fileId, fileName, filters, isOpen, onClose, parentFolderId = null, type = 'file' } = props

  return (
    <Dialog
      maxWidth='xs'
      fullWidth
      PaperProps={{
        sx: { overflow: 'visible', position: 'relative' }
      }}
      open={isOpen}
      onClose={onClose}
    >
      <DialogContent>
        <MentorCloudRenameForm
          filters={filters}
          fileId={fileId}
          fileName={fileName}
          parentFolderId={parentFolderId}
          onCancel={onClose}
          type={type}
        />
      </DialogContent>
    </Dialog>
  )
}
